export interface RuleMatched {
  id: string | number;
  didClassify?: boolean;
  rank?: number;
}

export interface ClassificationProgress {
  processed: number;
  total: number;
}
export const isClassificationProgress = (data: unknown): data is ClassificationProgress =>
  !!(data && typeof data === 'object' && 'total' in data && 'processed' in data);

export interface EvaluationResult {
  device_id: string;
  matchInfo: { interfaceCount?: number; interfacesClassifiedCount?: number; rulesUsed?: number };
  rules: { id: number; interfacesMatched: object[]; interfacesClassified: object[] }[];
  interfaces: {
    id: string;
    device_id: string;
    device_name: string;
    connectivity_type: string;
    initial_connectivity_type: string;
    network_boundary: string;
    initial_network_boundary: string;
    rules_matched: RuleMatched[];
  }[];
}

export const isEvaluationResult = (data: unknown): data is EvaluationResult =>
  !!(
    data &&
    typeof data === 'object' &&
    'device_id' in data &&
    'matchInfo' in data &&
    'rules' in data &&
    'interfaces' in data
  );

interface CompleteType {
  complete: true;
}

export const isCompleteType = (data: unknown): data is CompleteType =>
  !!(data && typeof data === 'object' && 'complete' in data && data.complete);

export interface ErrorType {
  error: string;
}

export const isErrorType = (data: unknown): data is ErrorType =>
  !!(data && typeof data === 'object' && 'error' in data && data.error);
